// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__fzUzx","inner":"Footer_inner__1uV-w","nextIcon":"Footer_nextIcon__6vEw_","innerLeft":"Footer_innerLeft__Ypd5Y"};